window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};


repos.casinoDobitciRepo = (function() {
  var url = "api/dobitci?v2";

  var get = function() {
    return fetch(url)
      .then(casino.repos.base.checkResponse)
      .then(function(response) {
        return response.json();
      })
      .catch(casino.repos.base.handleNetworkException);
  };

  return {
    get: get
  };
})();
